import { ServerFilterClauses } from '~commonInfra/utils/ServerFilterClauses';
import { ServerApiMapper } from '~commonInfra/utils/ServerModelHelper';
import { ExploreContentRequest } from '~src/spacesPlatform/serverApi/requests/ExploreContentRequest';
import { GetContentForUserRequest } from '~src/userManagement/serverApi/requests/GetContentForUserRequest';

import { ExploreFavoriteContentForUserRequest } from '../../favorites/requests/ExploreFavoriteContentForUserRequest';
import { ExploreFavoritedContentForUserRequest } from '../../favorites/requests/ExploreFavoritedContentForUserRequest';
import { IListFetcher } from '../../httpClient/fetchers/IListFetcher';
import { WebClientListResourceFetcher } from '../../httpClient/fetchers/resourceFetchers/WebClientListResourceFetcher';
import { ResourceQuery } from '../../httpClient/resources/ResourceQuery';
import { IContentInfo } from '../../spacesPlatform/models/IContentInfo';
import { ILeafFilterClause } from '../../spacesPlatform/models/IFilterClause';

class ContentResource {

  private exploreContentFetcher: IListFetcher<IContentInfo>;
  private exploreFavoritedContentForUser: IListFetcher<IContentInfo>;
  private exploreFavoriteContentForUser: IListFetcher<IContentInfo>;
  private getContentForUserFetcher: IListFetcher<IContentInfo>;

  constructor() {
    this.exploreContentFetcher = new WebClientListResourceFetcher(ExploreContentRequest, ServerApiMapper.content);
    this.exploreFavoritedContentForUser = new WebClientListResourceFetcher(ExploreFavoritedContentForUserRequest, ServerApiMapper.content);
    this.exploreFavoriteContentForUser = new WebClientListResourceFetcher(ExploreFavoriteContentForUserRequest, ServerApiMapper.favoriteFromCrass);
    this.getContentForUserFetcher = new WebClientListResourceFetcher(GetContentForUserRequest, ServerApiMapper.content);
  }

  public forProject(projectId: string, additionalFilterClauses?: ILeafFilterClause[]): ResourceQuery<IContentInfo> {
    return new ResourceQuery(this.exploreContentFetcher)
      .withExtraParams({ 'project': projectId })
      .withFilters(additionalFilterClauses);
  }

  public forPersonalSpace(ownerId: string, additionalFilterClauses: ILeafFilterClause[]): ResourceQuery<IContentInfo> {
    return new ResourceQuery(this.exploreContentFetcher)
      .withFilters(additionalFilterClauses.concat([
        ServerFilterClauses.serverFilterClauses.owner(ownerId),
        ServerFilterClauses.serverFilterClauses.usersPersonalSpaceContent('true')]));
  }

  public forUser(userId: string, additionalFilterClauses?: ILeafFilterClause[]): ResourceQuery<IContentInfo> {
    return new ResourceQuery(this.getContentForUserFetcher)
      .withExtraParams({ 'userId': userId })
      .withFilters(additionalFilterClauses);
  }

  public forFavorites(additionalFilterClauses?: ILeafFilterClause[]): ResourceQuery<IContentInfo> {
    return new ResourceQuery(this.exploreFavoritedContentForUser)
      .withFilters(additionalFilterClauses);
  }

  public forFavoritesFromCRASS(additionalFilterClauses?: ILeafFilterClause[]): ResourceQuery<IContentInfo> {
    return new ResourceQuery(this.exploreFavoriteContentForUser)
      .withFilters(additionalFilterClauses);
  }

  public forCurrentUser(additionalFilterClauses?: ILeafFilterClause[]): ResourceQuery<IContentInfo> {
    return new ResourceQuery(this.getContentForUserFetcher).withFilters(additionalFilterClauses);
  }

}

export const Content = new ContentResource;
